export default __webpack_public_path__ + "img/ic-invoice.2617f45b.svg";